import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap, map, catchError, finalize } from 'rxjs/operators';
import {
  InvestigationTypeRepository
} from '../../../infrastructure/repositories/investigation-type.repository';
import { InvestigationTypeState } from '../../states/investigation-type.state';
import { UpdateInvestigationTypeResult } from './update-investigation-type.result';
import { UpdateInvestigationTypeCommand } from './update-investigation-type.command';

@Injectable({ providedIn: 'root' })
export class UpdateInvestigationTypeUseCase {
  private readonly _repository = inject(InvestigationTypeRepository);
  private readonly _state = inject(InvestigationTypeState);

  public execute(id: string, params: UpdateInvestigationTypeCommand): Observable<UpdateInvestigationTypeResult> {
    this._state.setSaving(true);
    this._state.clearError();

    return this._repository.updateInvestigationType(id, params).pipe(
      switchMap(() =>
        this._repository.getAllInvestigationTypes().pipe(
          map((investigationTypes) => {
            this._state.setInvestigationTypes(investigationTypes);
            return { success: true };
          }),
        ),
      ),
      catchError((error) => {
        throw error;
      }),
      finalize(() => this._state.setSaving(false)),
    );
  }
}
